import { StyleSheet, Animated } from "react-native";
import React from "react";
import { Center, HStack } from "native-base";

type CenterProps = React.ComponentProps<typeof Center>;

interface PaginationProps extends CenterProps {
  items: any[];
  activeIndex: number;
}
const Pagination = (props: PaginationProps) => {
  const { items, activeIndex } = props;

  const [fadeAnim, setFadAnim] = React.useState(new Animated.Value(0));

  React.useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 2000,
      useNativeDriver: true,
    }).start();
  });

  const animatedStyle = {
    opacity: fadeAnim,
  };

  type CircleProps = {
    outline?: boolean;
  };
  const Circle = (props: CircleProps) => (
    <Animated.View
      {...props}
      style={[
        props.outline ? styles.circleOutline : styles.circle,
        animatedStyle,
      ]}
    ></Animated.View>
  );

  return (
    <Center {...props}>
      <HStack space={2}>
        {items.map((item, i) => (
          <Circle outline={i != activeIndex} key={i}></Circle>
        ))}
      </HStack>
    </Center>
  );
};

export default Pagination;

const styles = StyleSheet.create({
  circle: {
    width: 10,
    height: 10,
    backgroundColor: "rgba(255, 255, 255, 0.92)",
    borderRadius: 100,
  },
  circleOutline: {
    width: 10,
    height: 10,
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "#ffffff",
    borderRadius: 100,
  },
});
